module.exports = __webpack_public_path__ + "media/images/icone_lupa_azul-cf070a4b035b805d0557ed94d47f1602.svg";